module.exports = __webpack_public_path__ + "img/tab-open.783261d0.svg";